import styled, { css } from 'styled-components';
import { Checkbox as AntdCheckbox } from 'components/atoms/checkbox';
import { Radio as AntdRadio } from 'components/atoms/radio';

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FormElWrapper = css`
  width: 32px;
  flex-basis: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Radio = styled(AntdRadio)`
  display: flex;
  align-items: center;
  .ant-radio {
    ${FormElWrapper};
  }
`;

export const Checkbox = styled(AntdCheckbox)`
  margin-top: var(--spacing-06);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .ant-checkbox {
    ${FormElWrapper};
  }
`;

export const AutoAddOption = styled.div`
  padding: var(--spacing-04) 0;
`;

export const MemberAddWrapper = styled.div`
  .ant-radio-group {
    width: 80%;
  }
  .ant-radio-wrapper {
    white-space: normal;
  }
`;

export const UserSelectionWrapper = styled.div`
  padding-left: var(--spacing-07);
  padding-top: var(--spacing-04);
  .ozone-select--is-disabled {
    opacity: 0.5;
  }
`;
